module.exports = __webpack_public_path__ + "static/media/Wave.3418cb2c.mp3";